exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.btn-group[data-v-e88482c2] {\r\n    border: 1px solid #DEDEDE;\r\n    border-radius: 0.24rem !important;\r\n    display: flex;\n}\n.btn[data-v-e88482c2] {\r\n    flex: 0 0 calc(100% / 3);\r\n    border: none !important;\r\n    border-radius: 0.1875rem !important;\r\n    box-shadow: none !important;\n}\r\n", ""]);

// exports
